






















import Vue from 'vue';
import Component from 'vue-class-component';
import UserProfileCard from '@/components/UserProfileCard.vue';
import { mapGetters } from 'vuex';

@Component({
  layout: 'authenticated',
  components: {
    UserProfileCard,
  },
  computed: {
    ...mapGetters('user', {
      user: 'INFO',
      logoutUrl: 'LOGOUT_URL'
    })
  },
  mounted() {
    if (!this.user) {
     window.location.replace(this.logoutUrl);
    }
}
})

export default class IndexPage extends Vue {
}
